/* eslint-disable array-callback-return */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import React, { useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Alert, Upload, notification,
} from 'antd';
import Constants from '@Apis/constants';
import { InboxOutlined, LoadingOutlined } from '@ant-design/icons';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import InvoiceActions from '@Actions/invoiceActions';

const { Dragger } = Upload;
/**
 *
 */
function BulkReturns({
  user, createBulkReturnsLoading, callback, createBulkReturns,
}) {
  const [fileList, setFileList] = useState([]);
  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: '.xlsx,.xls,.csv',
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList,
    disabled: createBulkReturnsLoading,
    loading: createBulkReturnsLoading,
  };

  const onSubmit = () => {
    if (!fileList?.[0]) {
      notification.open({
        type: 'error',
        duration: 4,
        placement: 'top',
        message: 'Please select a file to continue',
      });
    } else {
      const payload = {
        file: fileList[0],
      };
      createBulkReturns(payload, () => {
        callback();
      });
    }
  };

  /**
     *
     * @return {JSX.Element}
     */
  return (
    <Fragment>
      <div className="bulk-import__wrapper">
        <div className="bulk-import__step">
          <label className="bulk-import__form-label">
            Please use the template below and upload the list of invoices
          </label>
          <Dragger {...uploadProps}>
            <Fragment>
              <p className="ant-upload-drag-icon">
                {createBulkReturnsLoading ? <LoadingOutlined /> : <InboxOutlined />}
              </p>
              <p className="ant-upload-text" style={{ fontSize: '13px !important' }}>Click or drag file to this area to upload</p>
              <p className="ant-upload-hint">
                (Supported formats .csv,.xlsx; max file size 5 MB)
              </p>
            </Fragment>
          </Dragger>
          <Alert
            showIcon
            message={(
              <div>
                <a
                  href={`${Constants.SHOPIFY}/bulk_return/template/download`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Click Here
                </a>
                {' '}
                to download the data template
              </div>
            )}
            type="warning"
            style={{ borderRadius: '4px', marginTop: '5px' }}
          />
          <div className="custom-drawer__footer flex-display" style={{ width: '100%' }}>
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text="Continue"
              onClick={() => onSubmit()}
              style={{
                borderRadius: '5px',
                padding: '9px 15px',
                width: '100px',
              }}
              disabled={!fileList?.length || createBulkReturnsLoading}
              isLoading={createBulkReturnsLoading}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, InvoiceReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  createBulkReturnsLoading: InvoiceReducers.bulkUpdateProductsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createBulkReturns: (payload, callback) => dispatch(InvoiceActions.createBulkReturns(payload, callback)),
});

BulkReturns.propTypes = {
  user: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkReturns));
